export type ProjectListDashboardHealthStatus =
    | "on_track"
    | "at_risk"
    | "critical"
    | "finalized";

export type ProjectListDashboardExportFormat = "csv" | "xlsx" | "pdf";

export interface ProjectListDashboardSummary {
    totalProjects: number;
    activeProjects: number;
    finalizedProjects: number;
    projectsWithAlerts: number;
    overdueActivities: number;
    upcomingActivities: number;
    atRiskIndicators: number;
    monitoringOverdueIndicators: number;
}

export interface ProjectListDashboardStatusBucket {
    key: ProjectListDashboardHealthStatus;
    label: string;
    count: number;
}

export interface ProjectListDashboardAlert {
    projectId: number;
    projectName: string;
    itemId: number;
    itemName: string;
    itemType: string;
    dueDate: string | null;
    phase: string | null;
    priority: string | null;
    status: string | null;
}

export interface ProjectListDashboardAlerts {
    overdueActivities: ProjectListDashboardAlert[];
    upcomingActivities: ProjectListDashboardAlert[];
    atRiskIndicators: ProjectListDashboardAlert[];
    monitoringOverdueIndicators: ProjectListDashboardAlert[];
}

export interface ProjectListDashboardProject {
    id: number;
    name: string;
    status: string;
    statusLabel: string;
    healthStatus: ProjectListDashboardHealthStatus;
    healthLabel: string;
    completionPercentage: number;
    totalActivities: number;
    completedActivities: number;
    overdueActivitiesCount: number;
    upcomingActivitiesCount: number;
    atRiskIndicatorsCount: number;
    offTrackIndicatorsCount: number;
    monitoringOverdueIndicatorsCount: number;
}

export interface ProjectListDashboard {
    summary: ProjectListDashboardSummary;
    statusOverview: ProjectListDashboardStatusBucket[];
    alerts: ProjectListDashboardAlerts;
    projects: ProjectListDashboardProject[];
}

export const createEmptyProjectListDashboard = (): ProjectListDashboard => ({
    summary: {
        totalProjects: 0,
        activeProjects: 0,
        finalizedProjects: 0,
        projectsWithAlerts: 0,
        overdueActivities: 0,
        upcomingActivities: 0,
        atRiskIndicators: 0,
        monitoringOverdueIndicators: 0,
    },
    statusOverview: [],
    alerts: {
        overdueActivities: [],
        upcomingActivities: [],
        atRiskIndicators: [],
        monitoringOverdueIndicators: [],
    },
    projects: [],
});
